//import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'

export default defineNuxtPlugin(async (nuxtApp) => {
  //nuxtApp.vueApp.use(PrimeVue, {})
  nuxtApp.vueApp.use(ConfirmationService)
  // NOTE: 必要なprimevueのディレクティブをここに設定していく
})
